import React from 'react';
import { Box } from '@mui/material';
import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import NotesIcon from '@mui/icons-material/Notes';
import TableChartOutlinedIcon from '@mui/icons-material/TableChartOutlined';
import InsightsOutlinedIcon from '@mui/icons-material/InsightsOutlined';
import BarChartOutlinedIcon from '@mui/icons-material/BarChartOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import TimelineIcon from '@mui/icons-material/Timeline';
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import PlaceOutlinedIcon from '@mui/icons-material/PlaceOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import WidgetsOutlinedIcon from '@mui/icons-material/WidgetsOutlined';
import PsychologyOutlinedIcon from '@mui/icons-material/PsychologyOutlined';
import ExtensionOutlinedIcon from '@mui/icons-material/ExtensionOutlined';

const ICONS = {
  chat: ChatBubbleOutlineIcon,
  summary: NotesIcon,
  table: TableChartOutlinedIcon,
  stats: InsightsOutlinedIcon,
  chart: BarChartOutlinedIcon,
  rich_text: ArticleOutlinedIcon,
  form: AssignmentOutlinedIcon,
  list: FormatListBulletedIcon,
  timeline: TimelineIcon,
  grid: GridViewOutlinedIcon,
  map: PlaceOutlinedIcon,
  image: ImageOutlinedIcon,
  skill_chat: PsychologyOutlinedIcon,
  plugin: ExtensionOutlinedIcon,
};

const TINTS = {
  chat: '#2563eb',
  summary: '#7c3aed',
  table: '#0891b2',
  stats: '#059669',
  chart: '#d97706',
  rich_text: '#475569',
  form: '#db2777',
  list: '#0d9488',
  timeline: '#9333ea',
  grid: '#4f46e5',
  map: '#16a34a',
  image: '#ea580c',
  skill_chat: '#7c3aed',
  plugin: '#0f766e',
};

export const panelTint = (kind) => TINTS[kind] || '#64748b';

export function PanelIcon({ kind, size = 36 }) {
  const Icon = ICONS[kind] || WidgetsOutlinedIcon;
  const tint = panelTint(kind);
  return (
    <Box
      sx={{
        width: size,
        height: size,
        borderRadius: 2,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flex: '0 0 auto',
        color: tint,
        bgcolor: `${tint}14`,
      }}
    >
      <Icon sx={{ fontSize: size * 0.55 }} />
    </Box>
  );
}

/** Tiny column diagram of a layout; `columns` is from layoutThumbnail(). */
export function LayoutSketch({ columns, accent = '#2563eb', height = 56 }) {
  return (
    <Box sx={{
      display: 'flex', gap: 0.5, height, width: '100%',
    }}
    >
      {columns.map(({ zone, kinds }) => (
        <Box
          key={zone}
          sx={{
            flex: zone === 'center' ? 1.3 : 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 0.5,
          }}
        >
          {(kinds.length ? kinds : [null]).map((kind, i) => (
            <Box
              // eslint-disable-next-line react/no-array-index-key
              key={i}
              sx={{
                flex: 1,
                borderRadius: 1,
                bgcolor: kind ? `${kind === 'chat' ? accent : panelTint(kind)}26` : 'action.hover',
                border: 1,
                borderColor: kind ? `${kind === 'chat' ? accent : panelTint(kind)}55` : 'divider',
                borderStyle: kind ? 'solid' : 'dashed',
              }}
            />
          ))}
        </Box>
      ))}
    </Box>
  );
}
